import { useState } from 'react';
import { toast } from 'sonner';
import { Music, Menu, X, Download, Loader2, Mic, Drum } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from '@/components/ui/alert-dialog';
import { useIsMobile } from '@/hooks/use-mobile';
import { useSidebar } from '@/components/ui/sidebar';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
interface SessionHeaderProps {
  filename?: string;
  sessionId: string | undefined;
  onDelete: (sessionId: string) => void;
  onDownloadAll?: () => void;
  showDownload?: boolean;
  isDownloading?: boolean;
}
export const SessionHeader = ({
  filename,
  sessionId,
  onDelete,
  onDownloadAll,
  showDownload = false,
  isDownloading = false
}: SessionHeaderProps) => {
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const isMobile = useIsMobile();
  const {
    toggleSidebar
  } = useSidebar();
  const handleDelete = () => {
    if (sessionId) {
      onDelete(sessionId);
      setIsOpenDelete(false);
    }
  };
  if (!filename) {
    return null;
  }

  // Get icon based on filename
  const getIcon = () => {
    if (filename.includes('vocal') || filename.includes('acapella') || window.location.pathname.includes('acapella')) {
      return <Mic className="h-6 w-6 text-white" />;
    } else if (filename.includes('drum') || window.location.pathname.includes('drum')) {
      return <Drum className="h-6 w-6 text-white" />;
    } else {
      return <Music className="h-6 w-6 text-white" />;
    }
  };
  return <div className="flex items-center justify-between max-w-full">
      <div className="flex items-center gap-2">
        {isMobile && <Button variant="ghost" size="icon" className="h-10 w-10 bg-black/10 hover:bg-black/20 mr-1" onClick={toggleSidebar}>
            <Menu className="h-4 w-4" />
          </Button>}
        <div className="flex items-center gap-2 truncate">
          {getIcon()}
          <h1 className="text-2xl font-semibold tracking-tight text-white truncate max-w-[25ch]">
            {filename}
          </h1>
        </div>
      </div>

      
    </div>;
};